module.exports = __webpack_public_path__ + "static/sec4-bg-1be52697035b21337e8023f77d2ce22c.jpg";